import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Parcels from "@/pages/Parcels";
import ParcelDetail from "@/pages/ParcelDetail";
import Capture from "@/pages/Capture";
import Compliance from "@/pages/Compliance";
import Team from "@/pages/Team";
import Notifications from "@/pages/Notifications";
import PortfolioMap from "@/pages/PortfolioMap";
import SharedProperty from "@/pages/SharedProperty";
import Analytics from "@/pages/Analytics";
import Activity from "@/pages/Activity";
import Renewals from "@/pages/Renewals";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/share/:token" element={<SharedProperty />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/parcels" element={<ProtectedRoute><Parcels /></ProtectedRoute>} />
            <Route path="/parcels/:id" element={<ProtectedRoute><ParcelDetail /></ProtectedRoute>} />
            <Route path="/parcels/:id/capture" element={<ProtectedRoute><Capture /></ProtectedRoute>} />
            <Route path="/map" element={<ProtectedRoute><PortfolioMap /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute adminOnly><Analytics /></ProtectedRoute>} />
            <Route path="/activity" element={<ProtectedRoute adminOnly><Activity /></ProtectedRoute>} />
            <Route path="/compliance" element={<ProtectedRoute><Compliance /></ProtectedRoute>} />
            <Route path="/renewals" element={<ProtectedRoute><Renewals /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute adminOnly><Team /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute adminOnly><Notifications /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
